"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDropdownMenuContext = exports.DropdownMenuContextProvider = void 0;
var _react = require("react");
var _compoundComponents = require("@clds/compound-components");
const context = /*#__PURE__*/(0, _react.createContext)(undefined);
const DropdownMenuContextProvider = context.Provider;
exports.DropdownMenuContextProvider = DropdownMenuContextProvider;
const useDropdownMenuContext = (0, _compoundComponents.createUseDefinedContext)(context, 'Please wrap your component with <DropdownMenu>');
exports.useDropdownMenuContext = useDropdownMenuContext;
//# sourceMappingURL=DropdownMenuContext.js.map